import React from 'react';
import { FaBell, FaClock } from 'react-icons/fa';
import './NotificationBar.css';

const NotificationBar = () => {
  const notifications = [
    {
      id: 1,
      text: "Abstract submission date is extended till 29th May, 2026",
      date: "",
      link: "/abstract-submission"
    },
    {
      id: 2,
      text: "Travel support for shortest route by bus (public transport) or AC 3-tier train will be provided upon submission of original bills",
      date: "",
      link: "/accommodation"
    },
    {
      id: 3,
      text: "Keynote speakers confirmed - Check the Speakers section",
      date: "",
      link: "/speakers"
    },
    {
      id: 4,
      text: "Download the Program Schedule",
      date: "",
      link: "/schedule.pdf"
    }
  ];

  const handleNotificationClick = (link) => {
    if (link.startsWith('/assets/')) {
      // Open PDF/document links in new tab
      window.open(link, '_blank');
    } else {
      // Navigate to internal routes
      window.location.href = link;
    }
  };

  return (
    <div className="notification-bar">
      <div className="notification-container">
        <div className="notification-icon">
          <FaBell />
          <span>Latest Updates</span>
        </div>
        <div className="notification-scroll">
          <div className="notification-content">
            {notifications.map((notification, index) => (
              <div 
                key={notification.id} 
                className="notification-item"
                onClick={() => handleNotificationClick(notification.link)}
              >
                <FaClock className="time-icon" />
                <span className="notification-date">{notification.date}</span>
                <span className="notification-text">{notification.text}</span>
                <span className="separator">•</span>
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {notifications.map((notification, index) => (
              <div 
                key={`${notification.id}-duplicate`} 
                className="notification-item"
                onClick={() => handleNotificationClick(notification.link)}
              >
                <FaClock className="time-icon" />
                <span className="notification-date">{notification.date}</span>
                <span className="notification-text">{notification.text}</span>
                <span className="separator">•</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationBar;
